import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardHeader, Col } from 'reactstrap';
import { Btn, H3, P } from '../../../../AbstractElements';
import { addserviceRequest, serviceAccount, serviceRequest, StbModem, Subscription, SubscriptionHistory } from '../../../../Constant';
import { useSelector } from 'react-redux';
import DataTable from 'react-data-table-component';
import { getClientUrlDataToken } from '../../../../Utils/restUtils';
import { getComplaint, getComplaintRole, getUserStb, getUserStbRole } from '../../../../CommonUrl';
import { StbColumns, userServiceAccountColumns, userServiceRequestColumns } from '../../../../Data/MockTable/UserTableHeader';
import { conditionalRowStyles } from '../../../Common/Rowstyle/Rowstyle';
import { Link, useNavigate } from 'react-router-dom';

const ServiceRequest = (props) => {
    const propsId = props.param;
    const authState = useSelector((state) => state.auth);
    const [stbList, setStbList] = useState([]);
    const [perPage, setPerPage] = useState(10);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate()

    useEffect(() => {
        stbData(currentPage, perPage);
    }, []);

    const handlePageChange = page => {
        stbData(page, perPage,);
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        stbData(page, newPerPage);
        setPerPage(newPerPage);
    };

    const stbData = async (page, size = perPage) => {

        let data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ?
            getComplaint + `?page=${page}&page_length=${size}&customer_id=${propsId}` : getComplaintRole + `?page=&page_length=&search=&customer_id=${propsId}`);

        if (data?.status === true) {
            const SerialNo = (page - 1) * size + 1;
            setStbList(data?.data?.data?.map((e, index) => {
                return {
                    Si: SerialNo + index,
                    stbNo: e.stb_no || 'N/A',
                    startDate: e.start_date || 'N/A',
                    serviceDueDate: e?.next_service_due_date || 'N/A',
                    area: e.area_name || 'N/A',
                    Status: e.status || 'N/A',
                    stbId: e?.service_account_id || '',
                    serviceRequestId: e?.complaint_no,
                    id: e?.id,
                    assigned: e?.assigned_to,
                    stbName: e?.service_account_name || 'N/A',
                    paymentStatus: e?.payment_status || 'N/A'


                }
            }))
            setTotalRows(data.data.total);

        }
        else if (data?.status === false) {
            return
        }
        else if (data.status >= 400 && data.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (data.status >= 500 && data.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        }
        else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
    };
    return (
        <Col sm="12" xl=" xl-100">
            <Card>
                <CardHeader className='d-flex justify-content-between'>
                    <H3 attrH3={{ style: { paddingLeft: '10px' } }}>{serviceRequest}</H3>
                    <div>
                         {(authState.userRole === 1 || authState.permissions.includes('store-complaint')) &&
                            <Link to={`${process.env.PUBLIC_URL}/service-request-add?customerId=${propsId}`} className="btn btn-primary me-2" style={{ marginLeft: '10px' }}>{addserviceRequest}</Link>
                        }
                    </div>
                </CardHeader>
                <CardBody>
                    <div className="order-history table-responsive" style={{ marginTop: '-40px', maxHeight: '300px' }}>
                        <DataTable
                            data={stbList}
                            columns={userServiceRequestColumns}
                            conditionalRowStyles={conditionalRowStyles}
                            pagination
                            paginationTotalRows={totalRows}
                            paginationDefaultPage={currentPage}
                            onChangeRowsPerPage={handlePerRowsChange}
                            onChangePage={handlePageChange}
                        />
                    </div>
                </CardBody>
            </Card>
        </Col>
    );
};

export default ServiceRequest;